import { createSlice } from "@reduxjs/toolkit";
import { encryptData, decryptData } from "../../utils/cryptoUtils";

const getPersistedUser = () => {
  try {
    const encryptedUser = localStorage.getItem("user");
    return encryptedUser ? decryptData(encryptedUser) : null;
  } catch (error) {
    console.error("Decryption error, clearing corrupted data:", error);
    localStorage.removeItem("user");
    return null;
  }
};

const getAuthStatus = () => {
  try {
    const status = localStorage.getItem("isAuthenticatedUser");
    return status ? JSON.parse(status) : false;
  } catch {
    return false;
  }
};

const authSlice = createSlice({
  name: "auth",
  initialState: {
    isAuthenticatedUser: getAuthStatus(),
    user: getPersistedUser(),
  },
  reducers: {
    setCredentials: (state, action) => {
      const { user, isAuthenticatedUser } = action.payload;
      try {
        const encryptedUser = encryptData(user);

        state.isAuthenticatedUser = isAuthenticatedUser;
        state.user = user;

        localStorage.setItem(
          "isAuthenticatedUser",
          JSON.stringify(isAuthenticatedUser)
        );
        localStorage.setItem("user", encryptedUser);
      } catch (error) {
        console.error("Encryption failed:", error);
        state.isAuthenticatedUser = false;
        state.user = null;
      }
    },
    logOut: (state) => {
      state.isAuthenticatedUser = false;
      state.user = null;
      localStorage.removeItem("user");
      localStorage.removeItem("isAuthenticatedUser");
      localStorage.clear();
    },
  },
});

export const { setCredentials, logOut } = authSlice.actions;

export default authSlice.reducer;

export const selectCurrentUser = (state) => state.auth.user;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticatedUser;
